<template>
  <v-dialog v-model="moveDialog" class="the-app-dialogs" persistent max-width="500px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
              <span class="px-3">{{ $t('Move Expired To Damaged') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end></v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="py-1 px-2">
                <v-menu offset-y v-model="damagedDateMenu" full-width max-width="290" :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="form.damaged_date"
                    :label="`${$t('damageDate Date')} *`"
                    prepend-inner-icon="event"
                    box
                    readonly
                    hide-details
                    name="damageDate Date"
                    background-color="white"
                    autocomplete="off"
                    :error="errors.has('damageDate Date')"
                    v-validate="'required|date_format:yyyy-MM-dd'"
                  />
                  <v-date-picker @change="damagedDateMenu = false" v-model="form.damaged_date" />
                </v-menu>
              </v-flex>

              <v-flex xs12 sm12 md12 class="pa-2">
                <v-textarea
                  id="move-focus-me"
                  v-model="form.damaged_note"
                  :label="$t('Damaged Note')"
                  box
                  hide-details
                  height="80"
                  background-color="white"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Move') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'move-expired-to-damaged',

  props: {
    moveDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnAddLoading: false,
      form: {
        damaged_date: ''
      },
      damagedDateMenu: false
    }
  },

  watch: {
    moveDialog: {
      immediate: false,
      handler() {
        if (this.moveDialog) {
          this.addEscKeyListener()
          this.$validator.pause()
          for (let key in this.form) {
            this.form[`${key}`] = null
          }
          this.form.damaged_date = this.$moment()
            .format()
            .substr(0, 10)

          this.$nextTick(() => {
            this.$validator.resume()
            // default veutify autofocus only one time works so we have to handled in this way.
            // document.getElementById('move-focus-me').focus()
          })
        }
      }
    }
  },

  methods: {
    ...mapActions({
      moveExpiredToDamagedProduct: 'inventoryExpired/moveExpiredToDamagedProduct'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.moveDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    validateBeforeSubmit() {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true

            this.moveExpiredToDamagedProduct(this.form)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                this.$emit('hidemodal')
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped />
